@let style = styleSg();
@let description = descriptionSg();

<div
  class="atn-notice"
  [ngClass]="{
    'atn-notice--error': style === StyleEnum.Error,
    'atn-notice--info': style === StyleEnum.Info,
    'atn-notice--success': style === StyleEnum.Success,
    'atn-notice--warning': style === StyleEnum.Warning,
  }"
>
  <div>
    <div class="atn-notice__content">
      <atn-ds-notice-icon [style]="style" />
      <div class="atn-notice__description">
        @if (description) {
          {{ description }}
        }
        <ng-content select="[description]" />
      </div>
    </div>
  </div>
</div>
